import React, { useState } from "react";
import { Modal, Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { Trans } from "react-i18next";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { unlinkThirdPartyAccount } from "Platform/routes/Profile/modules/ProfileModule";

import { openLinkInNewTab } from "modules/Services";

import classes from "./DrivePermissionModal.scss";
import { connect } from "react-redux";

const DrivePermissionModal = ({
  accountId,
  onAuthClick,
  unlinkThirdPartyAccount,
  openLinkInNewTab,
  closeModal,
  isPhotosPicker = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useI18n();

  const handleCloseModal = e => {
    e?.stopPropagation?.();
    closeModal();
  };

  const handleUpdatePermissions = async e => {
    e?.stopPropagation?.();

    setIsLoading(true);
    await unlinkThirdPartyAccount(accountId);
    setIsLoading(false);

    onAuthClick(e);

    closeModal();
  };

  const handleSupportPageClicked = e => {
    e?.stopPropagation?.();

    openLinkInNewTab({
      url:
        "https://support.toddleapp.com/en/articles/8612559-using-google-workspace-on-toddle",
    });
  };

  if (isLoading) {
    return <FullScreenLoader />;
  }

  return (
    <Modal
      hasOverlay
      onClose={handleCloseModal}
      width={"440px"}
      height="fit-content"
      zIndex={1151}
    >
      <Modal.Header>
        <div>{t("common:update_drive_permission")}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="text-body-1">
          <Trans
            i18nKey={
              isPhotosPicker
                ? "common:toddle_does_not_have_access_to_google_photos"
                : "common:toddle_does_not_have_access_to_drive_files"
            }
          >
            <span
              className={classes.articleLink}
              onClick={handleSupportPageClicked}
            ></span>
          </Trans>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.buttonContianer}>
          <Button
            size="large"
            variant="outlined-subtle"
            onClick={handleCloseModal}
          >
            {t("common:cancel")}
          </Button>
          <Button
            size="large"
            variant={"progressive"}
            onClick={handleUpdatePermissions}
          >
            {t("common:update")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreators = {
  openLinkInNewTab,
  unlinkThirdPartyAccount,
};
export default connect(null, mapActionCreators)(DrivePermissionModal);
